import axios from 'axios'
import {
  DELETE_MEDPASS_DOC,
  GET_MEMBERSHIP_BENIFITS,
  GET_MEMBERSHIP_PLAN_AND_PATIENT_DETAILS,
  GET_MEDPASS_DOC,
  MEMBERSHIP_TYPES,
  UPLOAD_MEDPASS,
} from '../utils/Endpoints'
import {
  ayuvubharosaMemberLineUpdate,
  deletePatientDocuments,
  getAbPatientDocuments,
  getPartnerByAbMembership,
  MEMBERSHIP_PROJECT_ID,
  REGISTRATION_PROJECT_ID,
  uploadPatientDocuments,
} from '../utils/constants'
import { abUpdated } from '../features/AB Membership/constants'
import KeycloakService from '../utils/keycloakService'
import { startSxpProxy } from '../utils/api'
import {
  modes,
  onboardFormMsgs,
  onBoardIntent,
  pedErrorMsg,
  pedSucessMsg,
  SaveOnboardFormDetails,
  updatePedString,
} from '../features/membership/models'

export const getMembershipDetails = async (
  muhId: string,
  membershipType: string
) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}/membership/lines?partner=${muhId}&mbr_type=${membershipType}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    const { data } = response?.data || {}
    if (data) {
      return {
        success: true,
        data: data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
export const getMembershipTypes = async () => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}${MEMBERSHIP_TYPES}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    const data = response?.data || {}
    if (data) {
      return {
        success: true,
        data: data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
export const getMembershipBenifits = async (id: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}${GET_MEMBERSHIP_BENIFITS}${id}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getMemberPlanAndPatientDetails = async (lineId: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}${GET_MEMBERSHIP_PLAN_AND_PATIENT_DETAILS}${lineId}`,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
export const updatePed = async (lineBody: any) => {
  try {
    const response: any = await axios.put(
      `${process.env.REACT_APP_ODOO_URL}${getPartnerByAbMembership}`,
      lineBody,
      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'Data Fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to Fetch Data',
      }
    }
  } catch (error: any) {
    console.error('Error: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
export const handleSubmitReferrerEdit = async (
  selectedReferrerData: any,
  referrerName: string,
  referrerMobile: string
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_ODOO_URL}${ayuvubharosaMemberLineUpdate}`,
      {
        line_id: selectedReferrerData?.id,
        refferer: referrerName,
        refferer_phone: referrerMobile,
      },

      {
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )
    // Reload the table data
    if (response?.data?.result?.Status === abUpdated) {
      return {
        success: true,
        message: 'Updated Suceessfully',
      }
    } else {
      return {
        success: false,
        message: 'Error Occured',
      }
    }
  } catch (error) {
    return {
      success: false,
      message: 'Error Occured',
    }
  }
}
export const getPatientDocuments = async (patientId: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_MEDPASS_DOC}${patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          membership: 'membership',
        },
      }
    )

    if (response?.data?.length > 0) {
      return {
        data: response?.data,
        success: true,
        message: 'Data Available',
      }
    } else {
      return {
        data: [],
        success: true,
        message: 'No Data',
      }
    }
  } catch (error: any) {
    console.error(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const UploadMedPassDocuments = async (patientId: any, data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPLOAD_MEDPASS}${patientId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          membership: 'membership',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const updatePedStatus = async (id: string, ped: string) => {
  const state = {
    id,
    ped,
  }

  try {
    const response = await startSxpProxy(
      REGISTRATION_PROJECT_ID,
      updatePedString,
      state
    )
    return {
      response: response?.data,
      success: true,
      message: pedSucessMsg,
    }
  } catch (error) {
    return {
      response: null,
      success: false,
      message: pedErrorMsg,
    }
  }
}
export const SaveOnboardForm = async (
  medicalAnswers: Record<string, '' | 'YES' | 'NO' | 'DK'>,
  medicalComments: Record<string, string>,
  patientId: string
) => {
  const payload = {
    patientId,
    answers: medicalAnswers,
    comments: medicalComments,
  }

  try {
    const response = await startSxpProxy(
      MEMBERSHIP_PROJECT_ID,
      SaveOnboardFormDetails,
      payload
    )

    return {
      status: response?.status || 200,
      data: response?.data,
      success: true,
      message: pedSucessMsg,
    }
  } catch (error) {
    console.error(error)
    return {
      status: 500,
      data: null,
      success: false,
      message: pedErrorMsg,
    }
  }
}

export const DeleteMedPassDocuments = async (
  patientId: any,
  fileName: string
) => {
  const token = KeycloakService?.getToken()
  try {
    const cleanedFileName = fileName
      .replace(/^dev\//, '')
      .replace('membership/', '')
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DELETE_MEDPASS_DOC}${patientId}/${cleanedFileName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          membership: 'membership',
        },
      }
    )
    const { data, success, message } = response?.data ?? {}
    return { data, success, message }
  } catch (error: any) {
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const deleteAbDocument = async (data: any, patientId: any) => {
  const token = KeycloakService?.getToken()
  const fileName = data?.fileName?.split('/')?.[1]
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${deletePatientDocuments}${patientId}/${fileName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.length > 0) {
      return {
        data: response?.data,
        success: true,
        message: 'Data Available',
      }
    } else {
      return {
        data: [],
        success: true,
        message: 'No Data',
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const onboardMember = async (lineId: number, partnerRef: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_ODOO_URL}/membership/onboard`,
      {
        params: {
          line_id: lineId,
          partner_ref: partnerRef,
        },
        headers: {
          'api-key': process.env.REACT_APP_ODOO_API_KEY || '',
        },
      }
    )

    return response.data
  } catch (error: any) {
    console.error('Error onboarding member:', error)
    throw error
  }
}
export const getPatientDocumentsByAb = async (patientId: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${getAbPatientDocuments}${patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.length > 0) {
      return {
        data: response?.data,
        success: true,
        message: 'Data Available',
      }
    } else {
      return {
        data: [],
        success: true,
        message: 'No Data',
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const UploadAbDocuments = async (patientId: any, data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${uploadPatientDocuments}${patientId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const saveOrUpdateOnboardForm = async (
  patientId: string,
  medicalAnswers: Record<string, '' | 'YES' | 'NO' | 'DK'>,
  medicalComments: Record<string, string>
) => {
  const payload = {
    patientId,
    answers: medicalAnswers,
    comments: medicalComments,
  }

  try {
    const qrRes = await startSxpProxy(
      MEMBERSHIP_PROJECT_ID,
      onBoardIntent?.getOnBoardFormById,
      { patientId }
    )

    const total = qrRes?.data?.total || 0
    const existingQR = qrRes?.data?.entry?.[0]?.resource

    if (total > 0 && existingQR?.id) {
      const res = await startSxpProxy(
        MEMBERSHIP_PROJECT_ID,
        onBoardIntent?.updateOnBoardForm,
        {
          ...payload,
          questionnaireResponseId: existingQR.id,
        }
      )

      return {
        success: true,
        data: res?.data,
        mode: modes?.updated,
      }
    } else {
      const res = await startSxpProxy(
        MEMBERSHIP_PROJECT_ID,
        SaveOnboardFormDetails,
        payload
      )

      return {
        success: true,
        data: res?.data,
        mode: modes?.created,
      }
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      data: null,
    }
  }
}
export const saveOnboardFormAndOnboardMember = async ({
  patientId,
  medicalAnswers,
  medicalComments,
  lineId,
  partnerRef,
}: {
  patientId: string
  medicalAnswers: Record<string, '' | 'YES' | 'NO' | 'DK'>
  medicalComments: Record<string, string>
  lineId: number
  partnerRef: string
}) => {
  try {
    const formRes = await saveOrUpdateOnboardForm(
      patientId,
      medicalAnswers,
      medicalComments
    )
    if (!formRes?.success) {
      throw new Error(onboardFormMsgs?.savesucess)
    }
    const onboardRes = await onboardMember(lineId, partnerRef)
    return {
      success: true,
      data: onboardRes,
      message: onboardFormMsgs?.saveAndonBoard,
    }
  } catch (error: any) {
    console.error(error)
    return {
      success: false,
      data: null,
      message: error?.response?.data || onboardFormMsgs?.failedOnBoard,
    }
  }
}

export const fetchMedicalHistoryForm = async (patientId: string) => {
  try {
    const qRes = await startSxpProxy(
      MEMBERSHIP_PROJECT_ID,
      onBoardIntent?.getOnBoardQuestion
    )
    const questionnaire = qRes?.data?.entry?.[0]?.resource || null
    const qrRes = await startSxpProxy(
      MEMBERSHIP_PROJECT_ID,
      onBoardIntent?.getOnBoardFormById,
      { patientId }
    )
    const questionnaireResponse = qrRes?.data?.entry?.[0]?.resource || null
    return {
      success: true,
      questionnaire,
      questionnaireResponse,
    }
  } catch (error) {
    console.error(error)
    throw error
  }
}
